export default __webpack_public_path__ + "static/media/library-grey.6686616c.svg";